import { render, staticRenderFns } from "./CreatePortfolioModalWrapper.vue?vue&type=template&id=14279ccf"
import script from "./CreatePortfolioModalWrapper.vue?vue&type=script&lang=js"
export * from "./CreatePortfolioModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports